import { gql } from '../../../__generated__/graphql/catalog'

export const GET_FEATURED_PRODUCT = gql(`
  query GetFeaturedProduct(
    $productGroupHandle: String!
    $color: String
    $fit: String
    $selectedColor: String
    $selectedFit: String
  ) {
    productGroup(
      handle: $productGroupHandle
      selectedColor: $selectedColor
      selectedFit: $selectedFit
    ) {
      id
      featuredProduct(color: $color, fit: $fit) {
        ...FeaturedProduct
        careInstructions
        collectionLinks {
          nodes {
            text
            href
          }
        }
        fitModel {
          description
          height
          images
          name
          pantsSize
          topSize
        }
        fitModelsDescriptions
        rawMaterials
        rtfFeatures
      }
    }
  }
`)
